import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { ConnectedAudioMicButtonProps } from "./ConnectedAudioMicButton.types";
import { AudioMicButton } from "./AudioMicButton";

export const ConnectedAudioMicButton: React.FC<ConnectedAudioMicButtonProps> =
  ({ startAudioTestCall }) => {
    const { deviceTesterState } = useDeviceTesterStateContext();

    return (
      <AudioMicButton
        audioTestState={deviceTesterState.audioTestState}
        startAudioTestCall={startAudioTestCall}
      />
    );
  };
